import copy from "copy-to-clipboard";

export const copyToClipboard = (text: string | undefined | null) => {
  try {
    if (typeof window !== "undefined") {
      const result = copy(text ?? "");
      if (!result) {
        console.error("Failed to copy text to clipboard.");
      }
    }
  } catch (error) {
    console.error("Error copying text to clipboard: ", error);
  }
};
